export enum FileStatus {
  Updated = 'UPDATED',
  New = 'NEW',
  Active = 'ACTIVE',
  Hide = 'HIDE'
}
